import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from '../src/redux/cart/store';  // Cấu hình redux-persist từ store.js
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css'; // Import CSS của ứng dụng
// Ngăn chặn menu chuột phải trên toàn bộ ứng dụng
document.addEventListener('contextmenu', (event) => {
  event.preventDefault();
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>

);

// Đo lường hiệu suất ứng dụng (tùy chọn)
reportWebVitals();
